import React from "react";
import getAxios from "../../hooks/useAxios";
import {
  Box,
  useTheme,
  Text,
  Skeleton,
  Flex,
  Icon,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  Button,
  Heading,
  useToast,
  Input,
} from "@chakra-ui/react";
import Cookies from "js-cookie";
import { Theme } from "../../theme";
import Nodata from "../../components/Nodata";
import { MdDeleteForever, MdOutlineModeEdit } from "react-icons/md";
import StatusConfirmationModal from "../../components/StatusConfirmModal";

const ListArea = () => {
  const theme = useTheme<Theme>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isAddAreaOpen,
    onOpen: onAddAreaOpen,
    onClose: onAddAreaClose,
  } = useDisclosure();

  const toast = useToast();

  const axios = getAxios();
  const access_token = Cookies.get("x-admin-auth");
  const [isDataFetching, setIsDataFetching] = React.useState(true);
  const [allArea, setAllArea] = React.useState<any>([]);
  const [areaIdToDelete, setAreaIdToDelete] = React.useState<any>();
  const [loading, setLoading] = React.useState(false);

  const [areaName, setAreaName] = React.useState("");

  const getAllArea = async (url: string) => {
    setIsDataFetching(true);
    try {
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("all drivers", res.data);
      setAllArea(res.data?.data);
    } catch (error) {
      console.log("error listing drivers", error);
    } finally {
      setIsDataFetching(false);
    }
  };

  const deleteArea = async () => {
    try {
      const res = await axios.delete(`/driving-areas/${areaIdToDelete}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("delete admin", res.data);
      await getAllArea("/driving-areas");
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddArea = async () => {
    try {
      setLoading(true);
      const data = {
        name: areaName.toLowerCase(),
        status: "active",
      };
      console.log("data", data);

      await axios.post(`/driving-areas`, data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      toast({
        title: `Area added`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      await getAllArea("/driving-areas");

      onAddAreaClose();
    } catch (error) {
      console.log("error sending notification", error);
      toast({
        title: "Something went wrong",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getAllArea("/driving-areas");
  }, []);

  return (
    <Box sx={{ height: "100%", width: "100%", padding: "0 1rem" }}>
      <Flex
        sx={{
          margin: "2.5rem 0 2rem 2rem",
          gap: "1rem",
          alignItems: "baseline",
        }}
      >
        <Text
          sx={{
            fontSize: theme.fontSizes.subHeading1,
          }}
        >
          All Driving Areas
        </Text>
        <Flex sx={{ flex: 1, justifyContent: "flex-end" }}>
          <Box
            sx={{
              marginRight: "1rem",
              padding: "0.5rem 1rem",
              cursor: "pointer",
              width: "max-content",
              height: "max-content",
              border: "1px solid",
              borderColor: theme.colors.primary.main,
              borderRadius: "0.5rem",
            }}
            onClick={() => {
              onAddAreaOpen();
            }}
          >
            <Text
              sx={{
                fontSize: "1rem",
                fontWeight: 900,
                color: theme.colors.primary.main,
              }}
            >
              Add Area
            </Text>
          </Box>
        </Flex>
      </Flex>
      <Box
        sx={{
          padding: "0 2rem",
          width: "35%",
        }}
      >
        <Skeleton isLoaded={isDataFetching ? false : true} minHeight={"20rem"}>
          {allArea && allArea.length !== 0 ? (
            <table>
              <thead>
                <tr>
                  <th>
                    <Text
                      sx={{
                        fontSize: theme.fontSizes.subHeading1,
                      }}
                    >
                      Area Name
                    </Text>
                  </th>
                  <th>
                    <Text
                      sx={{
                        fontSize: theme.fontSizes.subHeading1,
                      }}
                    >
                      Delete
                    </Text>
                  </th>
                </tr>
              </thead>
              <tbody>
                {allArea.map((item: any, index: number) => (
                  <tr>
                    <td>
                      <Text
                        sx={{
                          fontSize: theme.fontSizes.subHeading2,
                        }}
                      >
                        {item.name}
                      </Text>
                    </td>

                    {/* <td>
                      <Flex
                        sx={{
                          justifyContent: "center",
                          alignItems: "center",
                          height: "2.8rem",
                          width: "2.8rem",
                          borderRadius: "0.25rem",
                        }}
                      >
                        <Icon
                          as={MdOutlineModeEdit}
                          width={6}
                          height={6}
                          color={theme.colors.primary.main}
                          cursor="pointer"
                        />
                      </Flex>
                    </td> */}
                    <td>
                      <Flex
                        sx={{
                          justifyContent: "center",
                          // background: isActive ? theme.colors.bg.main : 'transparent',
                          alignItems: "center",
                          height: "2.8rem",
                          width: "2.8rem",
                          borderRadius: "0.25rem",
                          // _hover: isActive ? { backgroundColor: theme.colors.bg.main } : { backgroundColor: theme.colors.bg.paper },
                        }}
                        onClick={() => {
                          onOpen();
                          setAreaIdToDelete(item.id);
                        }}
                      >
                        <Icon
                          as={MdDeleteForever}
                          width={6}
                          height={6}
                          color={theme.colors.primary.main}
                          cursor="pointer"
                        />
                      </Flex>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <Box>
              <Nodata heading="No Area Listed" />
            </Box>
          )}
        </Skeleton>
      </Box>
      <StatusConfirmationModal
        heading="Are you sure want to delete area ?"
        isOpen={isOpen}
        onClose={onClose}
        handleApiCall={() => deleteArea()}
      ></StatusConfirmationModal>

      <AddAreaModal
        onClose={onAddAreaClose}
        isOpen={isAddAreaOpen}
        approvalLoading={loading}
        handleAddArea={handleAddArea}
        areaName={areaName}
        setAreaName={setAreaName}
      />
    </Box>
  );
};

export default ListArea;

function AddAreaModal({
  isOpen,
  onClose,
  handleAddArea,
  approvalLoading,
  areaName,
  setAreaName,
}: any) {
  const theme = useTheme<Theme>();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={true}
      isCentered={true}
      size="md"
      returnFocusOnClose={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton
          sx={{
            borderRadius: "50%",
            background: "transparent",
            top: "5%",
            left: "93%",
            transform: "translate(-100%)",
            width: "3rem",
            height: "3rem",
            color: theme.colors.primary.main,
            //@ts-ignore
            "&:hover": {
              background: "transparent",
            },
          }}
        />
        <ModalBody sx={{ borderRadius: "0.25rem" }}>
          <Box sx={{ margin: "6rem 1.5rem 2.5rem 1.5rem" }}>
            <Box mb={theme.space.xl}>
              <Heading size="md" mb={6}>
                Add Area
              </Heading>
            </Box>

            <Box mb={theme.space.xl}>
              <label>Area Name:</label>
              <Input
                type="text"
                value={areaName}
                onChange={(e) => setAreaName(e.target.value)}
                name="name"
                placeholder="Enter Area name"
                variant={"outline"}
              />
            </Box>
            <Box>
              <Button
                w="100%"
                h="3em"
                style={{
                  background: theme.colors.primary.main,
                  color: theme.colors.bg.main,
                }}
                isLoading={approvalLoading}
                variant="solid"
                size="contain"
                onClick={() => {
                  handleAddArea();
                }}
              >
                Add
              </Button>
            </Box>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
